import styled from "styled-components";

const Styles = styled.div`
    .frame-1000011197,
    .frame-1000011197 * {
        box-sizing: border-box;
    }
    .frame-1000011197 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .payment-method {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--heading-4-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-4-font-size, 14px);
        line-height: var(--heading-4-line-height, 20px);
        font-weight: var(--heading-4-font-weight, 600);
        position: relative;
    }
    .btn-xs-secondary {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const PaymentMethodHeader = ({ setToggleButton, toggleButton }) => {
    return (
        <Styles className="w-100">
            <div className="frame-1000011197">
                <div className="payment-method">Payment method</div>
                <div
                    className="btn-xs-secondary"
                    onClick={() => {
                        setToggleButton(!toggleButton);
                    }}>
                    <div className="button">See {toggleButton ? "less" : "more"}</div>
                </div>
            </div>
        </Styles>
    );
};

export default PaymentMethodHeader;
